import { render, staticRenderFns } from "./CommunityLockers.vue?vue&type=template&id=ad5c3824&scoped=true&"
import script from "./CommunityLockers.vue?vue&type=script&lang=ts&"
export * from "./CommunityLockers.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityLockers.vue?vue&type=style&index=0&id=ad5c3824&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5c3824",
  null
  
)

export default component.exports